import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDocumentRejected(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <rect
        width={76}
        height={94}
        x={50}
        y={13}
        stroke="url(#document_rejected_svg__a)"
        strokeWidth={10}
        rx={16}
      />
      <path stroke="#0D2B57" strokeLinecap="round" d="M67.5 34.5h41m-41 10h41" />
      <rect width={39} height={39} x={106.5} y={54.5} fill="#B01921" rx={19.5} />
      <rect width={39} height={39} x={106.5} y={54.5} stroke="#fff" rx={19.5} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M126 68v7m0 3v1"
      />
      <defs>
        <linearGradient
          id="document_rejected_svg__a"
          x1={88}
          x2={87.5}
          y1={13}
          y2={84}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#F9E1E1" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDocumentRejected);
export default ForwardRef;
